"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "CalendarsService", {
    enumerable: true,
    get: function() {
        return CalendarsService;
    }
});
const _common = require("@nestjs/common");
const _nocodbsdk = require("nocodb-sdk");
const _viewwebhookmanager = require("~/utils/view-webhook-manager");
const _apphooksservice = require("~/services/app-hooks/app-hooks.service");
const _helpers = require("~/helpers");
const _catchError = require("~/helpers/catchError");
const _models = require("~/models");
const _NocoCache = /*#__PURE__*/ _interop_require_default(require("~/cache/NocoCache"));
const _globals = require("~/utils/globals");
const _NocoSocket = /*#__PURE__*/ _interop_require_default(require("~/socket/NocoSocket"));
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
let CalendarsService = class CalendarsService {
    async calendarViewGet(context, param) {
        return await _models.CalendarView.get(context, param.calendarViewId);
    }
    async calendarViewCreate(context, param, ncMeta) {
        var _param_viewWebhookManager;
        var _param_calendar_title, _param_user, _param_user1;
        (0, _helpers.validatePayload)('swagger.json#/components/schemas/ViewCreateReq', param.calendar);
        if (context.schema_locked) {
            _catchError.NcError.get(context).schemaLocked();
        }
        const model = await _models.Model.get(context, param.tableId, ncMeta);
        param.calendar.title = (_param_calendar_title = param.calendar.title) == null ? void 0 : _param_calendar_title.trim();
        const existingView = await _models.View.getByTitleOrId(context, {
            titleOrId: param.calendar.title,
            fk_model_id: param.tableId
        }, ncMeta);
        if (existingView) {
            _catchError.NcError.get(context).duplicateAlias({
                type: 'view',
                alias: param.calendar.title,
                label: 'title',
                base: context.base_id,
                additionalTrace: {
                    table: param.tableId
                }
            });
        }
        const viewWebhookManager = (_param_viewWebhookManager = param.viewWebhookManager) != null ? _param_viewWebhookManager : (await new _viewwebhookmanager.ViewWebhookManagerBuilder(context, ncMeta).withModelId(param.tableId)).forCreate();
        const { id } = await _models.View.insertMetaOnly(context, {
            view: _extends({}, param.calendar, {
                fk_model_id: param.tableId,
                type: _nocodbsdk.ViewTypes.CALENDAR,
                base_id: model.base_id,
                source_id: model.source_id,
                created_by: (_param_user = param.user) == null ? void 0 : _param_user.id,
                owned_by: param.ownedBy || ((_param_user1 = param.user) == null ? void 0 : _param_user1.id)
            }),
            model,
            req: param.req
        }, ncMeta);
        const view = await _models.View.get(context, id, ncMeta);
        await _NocoCache.default.appendToList(context, _globals.CacheScope.VIEW, [
            view.fk_model_id
        ], `${_globals.CacheScope.VIEW}:${id}`);
        let owner = param.req.user;
        if (param.ownedBy) {
            owner = await _models.User.get(param.ownedBy);
        }
        this.appHooksService.emit(_nocodbsdk.AppEvents.CALENDAR_CREATE, {
            view: _extends({}, view, param.calendar),
            req: param.req,
            context,
            owner
        });
        await view.getView(context);
        _NocoSocket.default.broadcastEvent(context, {
            event: _nocodbsdk.EventType.META_EVENT,
            payload: {
                action: 'view_create',
                payload: view
            }
        }, context.socket_id);
        if (!param.viewWebhookManager) {
            (await viewWebhookManager.withNewViewId(view.id)).emit();
        }
        return view;
    }
    async calendarViewUpdate(context, param, ncMeta) {
        var _param_viewWebhookManager;
        var _param_req_user;
        (0, _helpers.validatePayload)('swagger.json#/components/schemas/CalendarUpdateReq', param.calendar);
        const view = await _models.View.get(context, param.calendarViewId, ncMeta);
        if (!view) {
            _catchError.NcError.viewNotFound(param.calendarViewId);
        }
        const viewWebhookManager = (_param_viewWebhookManager = param.viewWebhookManager) != null ? _param_viewWebhookManager : (await (await new _viewwebhookmanager.ViewWebhookManagerBuilder(context, ncMeta).withModelId(view.fk_model_id)).withViewId(view.id)).forUpdate();
        const oldCalendarView = await _models.CalendarView.get(context, param.calendarViewId, ncMeta);
        await _models.CalendarView.update(context, param.calendarViewId, param.calendar, ncMeta);
        let owner = param.req.user;
        if (view.owned_by && view.owned_by !== ((_param_req_user = param.req.user) == null ? void 0 : _param_req_user.id)) {
            owner = await _models.User.get(view.owned_by, ncMeta);
        }
        this.appHooksService.emit(_nocodbsdk.AppEvents.CALENDAR_UPDATE, {
            view: _extends({}, view, param.calendar),
            calendarView: param.calendar,
            oldCalendarView,
            req: param.req,
            context,
            owner
        });
        await view.getView(context);
        _NocoSocket.default.broadcastEvent(context, {
            event: _nocodbsdk.EventType.META_EVENT,
            payload: {
                action: 'view_update',
                payload: view
            }
        }, context.socket_id);
        if (!param.viewWebhookManager) {
            (await viewWebhookManager.withNewViewId(view.id)).emit();
        }
        return view;
    }
    constructor(appHooksService){
        this.appHooksService = appHooksService;
    }
};
CalendarsService = _ts_decorate([
    (0, _common.Injectable)(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _apphooksservice.AppHooksService === "undefined" ? Object : _apphooksservice.AppHooksService
    ])
], CalendarsService);
